import { isEmptyDocument } from 'datocms-structured-text-utils'
import { ItemIntegrationFragment } from 'generated/resources/graphql'

import { useCurrentSession } from 'modules/core/hooks/useCurrentSession'
import { useFeatureAvailability } from 'modules/core/hooks/useFeatureAvailability'

import { upsellableIntegrations } from 'modules/marketplace/components/Item/InstallWorkflow/UpsellModal/upsellableIntegrations'

import { usePayrollModuleAvailability } from '../usePayrollModuleAvailability'
import { useMarketplaceUserPermissions } from '../useUserPermissions'
import { useGetMarketplaceCompanyInstallations } from './companyInstallations/useGetMarketplaceCompanyInstallations'
import { useGetMarketplaceFormQuestions } from './formQuestions/useGetMarketplaceFormQuestions'

export const useShowIntegrationSettings = (integration?: ItemIntegrationFragment) => {
  const { installable, id, datoId, setupInformation } = integration || {}
  const { canInstallCompanyWideIntegration } = useMarketplaceUserPermissions()
  const { access, company } = useCurrentSession()

  const { data: companyInstallationsData, loading: loadingCompanyInstallations } =
    useGetMarketplaceCompanyInstallations(
      {
        // FIXME: We should arrange the components to call this hook only when there is an id
        integrationIds: [id || 0],
      },
      !installable
    )

  const { data: formQuestionsData, loading: loadingFormQuestions } = useGetMarketplaceFormQuestions(
    {
      integrationId: id || -1,
      companyId: company.id,
      accessId: access.id,
    },
    !installable
  )

  const questionPropertiesPresent = () => {
    if (formQuestionsData.at(0)) {
      const parsedFormQuestions = JSON.parse(formQuestionsData.at(0)?.formQuestions || '{}')
      return Object.keys(parsedFormQuestions).length > 0
    } else {
      return false
    }
  }

  const upsellableIntegration = datoId ? upsellableIntegrations[datoId] : null
  const { loading: featureAvailabilityLoading, featureAvailability: upsellingFeature } =
    useFeatureAvailability(upsellableIntegration?.id || '')

  const { hasPayrollModulesAvailable, isPayrollCategoryIntegration } =
    usePayrollModuleAvailability(integration)

  const loading = loadingCompanyInstallations || loadingFormQuestions || featureAvailabilityLoading
  const installationPresent = companyInstallationsData.length === 1

  const integrationAvailable = () => {
    if (!upsellableIntegration) return true
    if (isPayrollCategoryIntegration && !hasPayrollModulesAvailable) return false
    if (installationPresent) return true
    return upsellingFeature.available
  }

  const installedIntegrationWithQuestions = () => {
    if (!installable) return false
    if (installationPresent && questionPropertiesPresent()) return true
    return false
  }

  const informativeIntegrationWithSetup = () => {
    if (installable) return false
    return !isEmptyDocument(setupInformation ? JSON.parse(setupInformation) : null)
  }

  if (
    !loading &&
    canInstallCompanyWideIntegration &&
    integrationAvailable() &&
    (installedIntegrationWithQuestions() || informativeIntegrationWithSetup())
  )
    return true
  return false
}
